<template>
  <box-view class="notification-view" title="Trung tâm thông báo" @close="close">
    <div class="container py-4">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <notification-list 
            :notifications="notifications" 
            @mark-read="$emit('mark-read', $event)"
            @mark-all-read="$emit('mark-all-read')"
          />
        </div>
      </div>
    </div>
  </box-view>
</template>

<script>
import NotificationList from '../components/notifications/NotificationList.vue';

export default {
  name: 'NotificationView',
  components: {
    NotificationList
  },
  props: {
    notifications: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    close() {
      this.$router.back();
    }
  }
}
</script>
